import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ProductList from '../components/Products/ProductList';
import { fetchCategories } from '../redux/actions/categoryActions';
import { fetchTags } from '../redux/actions/tagActions';
import { fetchOptions } from '../redux/actions/productOptionActions';

const calculateTimeLeft = (endTime) => {
    const difference = endTime - new Date().getTime();
    if (difference <= 0) return "Finalizado";
  
    const days = Math.floor((difference / (1000 * 60 * 60 * 24)));
    const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((difference / (1000 * 60)) % 60);
    return `${days}d ${hours}h ${minutes}m`;
  };

const ProductsPage = () => {
    const dispatch = useDispatch();
    const discount = useSelector(state => state.discount.percentage);
    const endTime = useSelector(state => state.discount.endTime);

    useEffect(() => {
        const loadInitialData = async () => {
            try {
                // Cargamos todos los datos necesarios en paralelo
                await Promise.all([
                    dispatch(fetchCategories()),
                    dispatch(fetchTags()),
                    dispatch(fetchOptions())
                ]);
            } catch (error) {
                console.error('Error loading initial data:', error);
            }
        };

        loadInitialData();
    }, [dispatch]);

    return (
        <div className="min-h-screen bg-white py-12">
            <div className="container mx-auto px-4">
                <div className="space-y-8">
                    <div className="text-center">
                        <h1 className="text-4xl font-light tracking-tight text-gray-900 mb-4">
                            Archivo Deportivo
                        </h1>
                        <div className="border-b border-gray-300 w-24 mx-auto mb-6"></div>
                        
                        {discount ? (
                            // <div className="inline-block">
                            //     <div className="bg-black text-white px-4 py-2 text-sm font-medium tracking-wider">
                            //         DESCUENTO {discount}% 
                            //         {endTime ? ` · Finaliza en ${calculateTimeLeft(endTime)}` : ""}
                            //     </div>
                            // </div>

                            // ENVIO GRATIS
                            <div className="inline-block">
                                <div className="bg-black text-white px-4 py-2 text-sm font-medium tracking-wider">
                                    DESCUENTO {discount}% + Envio GRATIS a todo el pais
                                    {endTime ? ` · Finaliza en ${calculateTimeLeft(endTime)}` : ""}
                                </div>
                            </div>
                        ) : ''}
                    </div>
                    
                    <div className="border-t border-b border-gray-200 py-8">
                        <ProductList />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductsPage;